import { apiV3Typed } from 'Services/api/apiV3';
import { buildTypedResponse } from 'Utils/buildResponse';

import { getUserCookieKey } from '../utils';

export const createGiftLink = async (
  subjectId: string,
  subjectType: 'MarketCurrent' | 'Article' | 'VirtualAnalyst',
) => {
  const response = await apiV3Typed.post('account/{cookie_key}/shared_links', {
    path: {
      cookie_key: getUserCookieKey(),
    },
    body: {
      subject_id: subjectId,
      // @ts-expect-error [API Types]
      subject_type: subjectType,
    },
  });

  return buildTypedResponse(response, 'sharedLink');
};
